import { closeCurrentWebView } from "@/utils/native/interaction";
import { getThemeBgColor } from "@/utils/project";
import { linkToRoute } from "@/utils/router";

export default [
  {
    path: "/wt-owner-service-entry",
    name: "OwnerServiceEntry",
    meta: {
      title: "车主服务",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner" */ "@/views/owner/OwnerServiceEntry.vue"
      )
  },
  {
    path: "/wt-claim-verify-owner",
    name: "ClaimVerifyOwner",
    meta: {
      title: "质保理赔",
      showHeader: true,
      rightText: "售后记录",
      rightClick: linkToRoute({ name: "AfterSaleRecord" })
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-claim" */ "@/views/owner/claim/ClaimVerifyOwner.vue"
      )
  },
  {
    path: "/wt-warranty-card/:phone",
    name: "WarrantyCard",
    meta: {
      title: "质保卡",
      background: getThemeBgColor, //"var(--theme-color--)", //"var(--theme-gradient-color--)",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-claim" */ "@/views/owner/claim/WarrantyCard.vue"
      )
  },
  {
    path: "/wt-apply-after-sales/:code/:card",
    name: "ApplyAfterSales",
    meta: {
      title: "申请售后",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-claim" */ "@/views/owner/claim/ApplyAfterSales.vue"
      )
  },
  {
    path: "/wt-apply-claim-success",
    name: "ApplyClaimSuccess",
    meta: {
      title: ""
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-claim" */ "@/views/owner/claim/ApplyClaimSuccess.vue"
      )
  },
  {
    path: "/wt-after-sale-record",
    name: "AfterSaleRecord",
    meta: {
      title: "理赔记录"
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-after-sale" */ "@/views/owner/after-sale/AfterSaleRecord.vue"
      )
  },
  {
    path: "/wt-after-sale-record-search",
    name: "AfterSaleRecordSearch",
    meta: {
      title: "理赔搜索"
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-after-sale" */ "@/views/owner/after-sale/AfterSaleRecordSearch.vue"
      )
  },
  {
    path: "/wt-after-sale-detail/:code",
    name: "AfterSaleDetail",
    meta: {
      title: "售后详情",
      showHeader: true,
      background: "#f5f5f5"
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-after-sale" */ "@/views/owner/after-sale/AfterSaleDetail.vue"
      )
  },
  {
    path: "/wt-after-sale-reapply",
    name: "AfterSaleReapply",
    meta: {
      title: "申请售后",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-after-sale" */ "@/views/owner/after-sale/AfterSaleReapply.vue"
      )
  },
  {
    path: "/wt-owner-winning-record",
    name: "OwnerWinningRecord",
    meta: {
      // background: "transparent"
      // showHeader: true,
      background: getThemeBgColor, //"var(--theme-gradient-color--)"
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-winning" */ "@/views/owner/winning/OwnerWinningRecord.vue"
      )
  },
  {
    path: "/wt-coupon-redeem-home",
    name: "CouponRedeemHome",
    meta: {
      title: "",
      background: getThemeBgColor //"var(--theme-color--)" //"var(--theme-gradient-color--)"
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-coupon-redeem" */ "@/views/owner/coupon-redeem/Index.vue"
      )
  },
  {
    path: "/wt-coupon-redeem/:code",
    name: "CouponRedeem",
    meta: {
      title: "优惠券兑换",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-coupon-redeem" */ "@/views/owner/coupon-redeem/Redeem/Index.vue"
      )
  },
  {
    path: "/wt-coupon-redeem-history",
    name: "CouponRedeemHistory",
    meta: {
      title: "兑换记录",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-coupon-redeem" */ "@/views/owner/coupon-redeem/History.vue"
      )
  },
  {
    path: "/wt-coupon-redeem-desc",
    name: "CouponRedeemDesc",
    meta: {
      title: "说明",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "owner-coupon-redeem" */ "@/views/owner/coupon-redeem/Desc.vue"
      )
  }
];
